module.exports = __webpack_public_path__ + "static/media/error404.9c569e8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error404.jpg
// module id = 649
// module chunks = 1